/**
 * launch_time_series 编辑器：targeting_id="totalday"（全天）或 "8_22"（起_止时），
 * ext_info=描述串（如「目前全天投放」）。全天/时段 select + 起止小时 + 描述。
 */
import type { EditorProps } from "./types";

export function LaunchTimeEditor({ item, onChange }: EditorProps) {
  const raw = item.targeting_id.trim();
  const isTotal = raw === "totalday" || raw === "";
  const range = isTotal ? null : raw.split("_").map((t) => Number(t));
  const startHour = range && range.length === 2 && Number.isInteger(range[0]) ? range[0] : 8;
  const endHour = range && range.length === 2 && Number.isInteger(range[1]) ? range[1] : 22;

  function setMode(total: boolean) {
    onChange({
      targeting_id: total ? "totalday" : `${startHour}_${endHour}`,
      ext_info: item.ext_info ?? "",
    });
  }
  function setStart(h: number) {
    onChange({ targeting_id: `${h}_${endHour}`, ext_info: item.ext_info ?? "" });
  }
  function setEnd(h: number) {
    onChange({ targeting_id: `${startHour}_${h}`, ext_info: item.ext_info ?? "" });
  }
  function setDesc(v: string) {
    onChange({ targeting_id: item.targeting_id, ext_info: v });
  }

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <select
          className="leo-select"
          value={isTotal ? "totalday" : "range"}
          onChange={(e) => setMode(e.target.value === "totalday")}
        >
          <option value="totalday">全天投放</option>
          <option value="range">指定时段</option>
        </select>
        {!isTotal ? (
          <>
            <input
              type="number"
              min={0}
              max={23}
              className="leo-input w-16"
              value={startHour}
              onChange={(e) => setStart(Number(e.target.value))}
            />
            <span className="text-[12px] text-text-muted">时</span>
            <span className="text-text-muted">~</span>
            <input
              type="number"
              min={0}
              max={23}
              className="leo-input w-16"
              value={endHour}
              onChange={(e) => setEnd(Number(e.target.value))}
            />
            <span className="text-[12px] text-text-muted">时</span>
          </>
        ) : null}
      </div>
      <div>
        <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-text-strong">
          说明
        </div>
        <input
          type="text"
          className="leo-input"
          value={item.ext_info ?? ""}
          onChange={(e) => setDesc(e.target.value)}
          placeholder="如：目前全天投放"
        />
      </div>
    </div>
  );
}
